import { MandateStatusColor } from "./mandate";

export function getMandateStatusStyles(status: MandateStatusColor, theme) {
  switch (status) {
    case MandateStatusColor.SUCCESS:
      return {
        color: theme.colors.success[500],
        backgroundColor: theme.colors.success[100],
      };
    case MandateStatusColor.WARNING:
      return {
        color: theme.colors.warning[500],
        backgroundColor: theme.colors.warning[100],
      };
    case MandateStatusColor.GRAY:
      return {
        color: theme.colors.gray[500],
        backgroundColor: theme.colors.gray[100],
      };
    default:
      return;
  }
}
